import {
  Type,
  Activity,
  AlignJustify,
  GitFork,
  GitMerge,
  Archive,
  ArchiveRestore,
  ArrowDownToLine,
  ArrowLeft,
  ArrowLeftRight,
  ArrowRight,
  ArrowUpToLine,
  Banknote,
  BarChart,
  Blocks,
  Book,
  BookOpen,
  Calculator,
  Calendar,
  Calendar1,
  CalendarClock,
  Check,
  CheckCircle,
  ChevronDown,
  ChevronRight,
  Circle,
  CircleAlert,
  CircleCheck,
  CircleDashed,
  CircleX,
  Clipboard,
  ClipboardList,
  Clock,
  Code2,
  CloudCog,
  CloudUpload,
  Columns,
  Copy,
  createIcons,
  Database,
  Download,
  HardDrive,
  Edit,
  Ellipsis,
  Eraser,
  Expand,
  UnfoldVertical,
  FoldVertical,
  Eye,
  EyeOff,
  File,
  FileBarChart,
  FileCode,
  FileDiff,
  FileSpreadsheet,
  FileText,
  FileWarning,
  FileUp,
  FilePen,
  Filter,
  Flag,
  FlaskConical,
  Folder,
  Glasses,
  GripHorizontal,
  GripVertical,
  Hand,
  Hash,
  History,
  House,
  Info,
  Key,
  Layers,
  Lightbulb,
  List,
  ListChecks,
  ListPlus,
  Lock,
  Play,
  Plug2,
  Loader2,
  LoaderCircle,
  LogOut,
  Mail,
  MemoryStick,
  Menu,
  Minus,
  Package,
  Paperclip,
  Pencil,
  Percent,
  Pin,
  Plus,
  RefreshCcw,
  RefreshCw,
  Rocket,
  RotateCw,
  Save,
  Search,
  Send,
  Settings,
  Sliders,
  Spline,
  SlidersHorizontal,
  Square,
  SquareCheck,
  Table,
  Table2,
  Tag,
  Terminal,
  Trash,
  Trash2,
  TriangleAlert,
  Upload,
  User,
  UserCheck,
  UserMinus,
  Users,
  Wallet,
  WandSparkles,
  Warehouse,
  Workflow,
  X,
  XCircle,
  // Financial, charts, dashboard, analytics icons
  TrendingUp,
  TrendingDown,
  ChartArea,
  ChartBar,
  ChartLine,
  ChartPie,
  ChartCandlestick,
  ChartScatter,
  ChartGantt,
  Receipt,
  CreditCard,
  Coins,
  DollarSign,
  Euro,
  IndianRupee,
  Landmark,
  Briefcase,
  Building2,
  Target,
  Gauge,
  Scale,
  PiggyBank,
  Vault,
  Handshake,
  BadgeDollarSign,
  BadgePercent,
  LayoutDashboard,
  Kanban,
  TrendingUpDown,
  ArrowDown,
  ArrowUp,
  // Machinery / industrial
  Cog,
  Cpu,
  HardHat,
  Wrench,
  Hammer,
  Factory,
  Forklift,
  Tractor,
  Construction,
  Drill,
  // Warehouse / logistics / parts
  PackageOpen,
  PackageCheck,
  PackagePlus,
  PackageSearch,
  Package2,
  Boxes,
  Container,
  Truck,
  TruckElectric,
  Ship,
  Plane,
  Train,
  // Cubes / shapes / components
  Box,
  Component,
  Puzzle,
  LayoutGrid,
  Shapes,
  Hexagon,
  Triangle,
  // More charts / analytics
  Sigma,
  PieChart,
  LineChart,
  AreaChart,
  ScatterChart,
  BarChart2,
  BarChart3,
  BarChart4,
  // Reports / documents
  Notebook,
  NotebookPen,
  NotebookText,
  ScrollText,
  Files,
  FolderOpen,
  ClipboardCheck,
  // More financials
  CircleDollarSign,
  ReceiptText,
  HandCoins,
  Bitcoin,
  PoundSterling,
  JapaneseYen,
  // Data / infra
  DatabaseBackup,
  DatabaseZap,
  Server,
  ServerCog,
  Network,
  // Business / locations
  Building,
  Store,
  MapPin,
  Map,
  Globe,
  Compass,
  // Energy / utilities
  Zap,
  Fuel,
  Battery,
  Flame,
  // Time
  Timer,
  AlarmClock,
  Hourglass,
  CalendarDays,
  Bell,
  // People
  UserCog,
  UserPlus,
  Contact,
  // Commerce / misc (FA migration)
  Heart,
  Umbrella,
  FolderTree,
  Inbox,
  Ban,
  CheckCheck,
  Tags,
  CalendarX,
  ThumbsUp,
  Car,
  RotateCcw,
  ShoppingCart,
  Gamepad2,
  CalendarCheck,
  Megaphone,
  Fingerprint,
  Asterisk,
  ArrowUpDown,
  AtSign,
  CircleHelp,
  EllipsisVertical,
  Palette,
  Route,
  SquarePlus,
  Equal,
  EqualNot,
  ChevronLeft,
  ChevronsLeft,
  ChevronsRight,
  StickyNote,
  Trophy,
  // Chat UI icons
  Sparkles,
  PanelLeftClose,
  PanelLeftOpen,
  MessageSquareDashed,
  MessageSquare,
  SquarePen,
  Mic,
  MicOff,
  CornerRightUp,
  // MDM and O2C icons
  MapPinned,
  ShieldCheck,
  Shield,
  BadgeCheck,

} from "lucide";

export function startIcons(rootElement) {
  createIcons({
    icons: {
      Activity,
      Save,
      Table,
      Table2,
      Menu,
      Folder,
      Settings,
      Plus,
      Columns,
      Users,
      ArchiveRestore,
      Archive,
      Trash,
      Loader2,
      ChevronRight,
      House,
      LogOut,
      CircleAlert,
      CircleCheck,
      Eye,
      EyeOff,
      Search,
      Type,
      AlignJustify,
      GitFork,
      GitMerge,
      CircleDashed,
      CircleX,
      Minus,
      ChevronDown,
      Edit,
      Pencil,
      X,
      Calendar,
      Calendar1,
      CalendarClock,
      Copy,
      Calculator,
      Ellipsis,
      Eraser,
      Filter,
      ArrowDownToLine,
      ArrowLeft,
      ArrowRight,
      ArrowUpToLine,
      GripHorizontal,
      Info,
      FileSpreadsheet,
      TriangleAlert,
      Upload,
      Download,
      Clipboard,
      Mail,
      Check,
      Pin,
      History,
      Send,
      SquareCheck,
      Square,
      Expand,
      UnfoldVertical,
      FoldVertical,
      Glasses,
      MemoryStick,
      Circle,
      Layers,
      Lightbulb,
      List,
      Lock,
      Paperclip,
      ArrowUpDown,
      AtSign,
      CircleHelp,
      EllipsisVertical,
      Palette,
      RotateCcw,
      Route,
      SquarePlus,
      Equal,
      EqualNot,
      ChevronLeft,
      ChevronsLeft,
      ChevronsRight,
      Inbox,
      StickyNote,
      Trophy,
      Warehouse,
      Book,
      BookOpen,
      File,
      FileCode,
      Tag,
      RefreshCw,
      RotateCw,
      GripVertical,
      Package,
      Blocks,
      ArrowLeftRight,
      Percent,
      Wallet,
      Banknote,
      FileDiff,
      Database,
      HardDrive,
      ClipboardList,
      FileBarChart,
      Key,
      Hash,
      FileText,
      FileWarning,
      LoaderCircle,
      ListPlus,
      ListChecks,
      Clock,
      Plug2,
      Trash2,
      Sliders,
      Spline,
      SlidersHorizontal,
      Code2,
      CloudCog,
      CloudUpload,
      FlaskConical,
      Terminal,
      Rocket,
      WandSparkles,
      BarChart,
      FileUp,
      FilePen,
      Workflow,
      Play,
      Hand,
      CheckCircle,
      XCircle,
      RefreshCcw,
      Flag,
      User,
      UserCheck,
      UserMinus,
      // Financial, charts, dashboard, analytics icons
      TrendingUp,
      TrendingDown,
      ChartArea,
      ChartBar,
      ChartLine,
      ChartPie,
      ChartCandlestick,
      ChartScatter,
      ChartGantt,
      Receipt,
      CreditCard,
      Coins,
      DollarSign,
      Euro,
      IndianRupee,
      Landmark,
      Briefcase,
      Building2,
      Target,
      Gauge,
      Scale,
      PiggyBank,
      Vault,
      Handshake,
      BadgeDollarSign,
      BadgePercent,
      LayoutDashboard,
      Kanban,
      TrendingUpDown,
      ArrowDown,
      ArrowUp,
      // Machinery / industrial
      Cog,
      Cpu,
      HardHat,
      Wrench,
      Hammer,
      Factory,
      Forklift,
      Tractor,
      Construction,
      Drill,
      // Warehouse / logistics / parts
      PackageOpen,
      PackageCheck,
      PackagePlus,
      PackageSearch,
      Package2,
      Boxes,
      Container,
      Truck,
      TruckElectric,
      Ship,
      Plane,
      Train,
      // Cubes / shapes / components
      Box,
      Component,
      Puzzle,
      LayoutGrid,
      Shapes,
      Hexagon,
      Triangle,
      // More charts / analytics
      Sigma,
      PieChart,
      LineChart,
      AreaChart,
      ScatterChart,
      BarChart2,
      BarChart3,
      BarChart4,
      // Reports / documents
      Notebook,
      NotebookPen,
      NotebookText,
      ScrollText,
      Files,
      FolderOpen,
      ClipboardCheck,
      // More financials
      CircleDollarSign,
      ReceiptText,
      HandCoins,
      Bitcoin,
      PoundSterling,
      JapaneseYen,
      // Data / infra
      DatabaseBackup,
      DatabaseZap,
      Server,
      ServerCog,
      Network,
      // Business / locations
      Building,
      Store,
      MapPin,
      Map,
      Globe,
      Compass,
      // Energy / utilities
      Zap,
      Fuel,
      Battery,
      Flame,
      // Time
      Timer,
      AlarmClock,
      Hourglass,
      CalendarDays,
      Bell,
      // People
      UserCog,
      UserPlus,
      Contact,
      // Commerce / misc (FA migration)
      Heart,
      Umbrella,
      FolderTree,
      Inbox,
      Ban,
      CheckCheck,
      Tags,
      CalendarX,
      ThumbsUp,
      Car,
      RotateCcw,
      ShoppingCart,
      Gamepad2,
      CalendarCheck,
      Megaphone,
      Fingerprint,
      Asterisk,
      // Chat UI icons
      Sparkles,
      PanelLeftClose,
      PanelLeftOpen,
      MessageSquareDashed,
      MessageSquare,
      SquarePen,
      Mic,
      MicOff,
      CornerRightUp,
      // MDM and O2C icons
      MapPinned,
      ShieldCheck,
      Shield,
      BadgeCheck,
    },
    root: rootElement || document.body,
    attrs: {
      "stroke-width": 1.5,
    },
  });
}
